export default __webpack_public_path__ + "static/media/ic-more-black-vertical.d61bf288.svg";